import { FC, useMemo } from "react";
import TableComponent, {
  TableProps,
} from "../../../../../../../common/components/table/table.component";
import uuidService from "../../../../../../../common/utils/uuid/uuid.service";
import { useAppContext } from "../../../../../../../context/app.context";
import OrderOptimizerTaxiDetailsHiddenDetailsHeadingTablesOrderTableRow from "../types/order-optimizer-taxi-details-hidden-details-heading-tables-order-table-row";
import orderOptimizerTaxiDetailsHiddenDetailsHeadingTablesOrderTableHelper from "./order-optimizer-taxi-details-hidden-details-heading-tables-order-table.helper";
import OrderOptimizerDetailsTableDotComponent from "../../../../../common/dot/order-optimizer-details-orders-table-dot.component";
import { OrderOptimizerTaxiDetailsItemStepsHomeToStart } from "../../../common/types/order-optimizer-taxi-details-item";

type OrderOptimizerTaxiDetailsHiddenDetailsHeadingTablesOrderTableProps = Pick<
  TableProps,
  "isError" | "isLoading"
> & {
  detailsStepsHomeToStartItems: OrderOptimizerTaxiDetailsItemStepsHomeToStart | null;
};

const OrderOptimizerTaxiDetailsHiddenDetailsHeadingTablesOrderTableComponent: FC<
  OrderOptimizerTaxiDetailsHiddenDetailsHeadingTablesOrderTableProps
> = (props) => {
  const { selectedAppLanguage } = useAppContext();

  const columns = useMemo(() => {
    return orderOptimizerTaxiDetailsHiddenDetailsHeadingTablesOrderTableHelper.getColumns();
  }, [selectedAppLanguage]);

  const createTableRow = (
    detailsStepsHomeToStartItems: OrderOptimizerTaxiDetailsItemStepsHomeToStart
  ): OrderOptimizerTaxiDetailsHiddenDetailsHeadingTablesOrderTableRow => {
    const dotColor = "#d9d9d9";

    const index = 0;

    return {
      id: uuidService.generate(),
      value: {
        humanId: (
          <div className="order_optimizer_taxi_details_hidden_details_order__humanId">
            <span title={String(index)}>{index}</span>
            <OrderOptimizerDetailsTableDotComponent color={dotColor} />
          </div>
        ),
        address: (
          <div title={detailsStepsHomeToStartItems.displayName}>
            {detailsStepsHomeToStartItems.displayName}
          </div>
        ),
        totalTime: <div />,
        haltingTime: <div />,
        distance: <div />,
      },
    };
  };

  const rows: OrderOptimizerTaxiDetailsHiddenDetailsHeadingTablesOrderTableRow[] =
    useMemo(() => {
      if (!props.detailsStepsHomeToStartItems) return [];

      const orderRows = createTableRow(props.detailsStepsHomeToStartItems);

      return [orderRows];
    }, [props.detailsStepsHomeToStartItems, selectedAppLanguage]);

  return (
    <TableComponent
      columns={columns}
      rows={rows}
      isLoading={props.isLoading}
      isError={props.isError}
    />
  );
};

export default OrderOptimizerTaxiDetailsHiddenDetailsHeadingTablesOrderTableComponent;
